import { Component, Vue } from "vue-property-decorator";
import { Finish, FinishHandle } from "@/models/products/finish";
import { Preset } from "@/models/configurator/configurator_options";

@Component
export class FinishHelpers extends Vue {
  protected getFinishImg(handle: string | FinishHandle, isFinishGroup = false): string {
    const ext = isFinishGroup ? "svg" : "jpg";
    let img = "";
    for (const value in FinishHandle) {
      if (handle === "msa" || handle === "ss" || handle === "gs") {
        img = require(`../assets/images/finishes/ms.${ext}`);
      } else if (FinishHandle[value] === handle) {
        img = require(`../assets/images/finishes/${handle}.${ext}`);
      }
    }
    return img;
  }

  protected getOrderedFinishes(finishes: Finish[]): Finish[] {
    const orderedFinishes: Finish[] = [];
    const finishOrder = Object.values(FinishHandle);

    finishOrder.forEach(handle => {
      const finish = finishes.find(finish => finish.handle === handle);
      if (finish) {
        orderedFinishes.push(finish);
      }
    });

    return orderedFinishes;
  }
}

@Component
export class ClearAllPresetDesigns extends Vue {
  protected clearAllPresetDesigns(): void {
    Object.keys(Preset).forEach(preset => {
      localStorage.removeItem(`shadeDesigner-${preset}`);
    });
  }
}

@Component
export class UmbrellaHelpers extends Vue {
  protected getUmbrellaModelDisplayName(model: string): string {
    return model.startsWith("464FM") ? model.replace("464FM", "864FM") : model;
  }
}
